import { type InferInsertModel, type InferSelectModel, relations } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';
import { shirtTypeCollarTypes } from './compatibility';

export const collarTypes = pgTable('collar_types', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  description: text('description').notNull(),
  price: doublePrecision('price').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export const collarTypesRelations = relations(collarTypes, ({ many }) => ({
  shirtTypeCollarTypes: many(shirtTypeCollarTypes),
}));

export type CollarType = InferSelectModel<typeof collarTypes>;
export type CreateCollarTypeInput = InferInsertModel<typeof collarTypes>;
export type UpdateCollarTypeInput = Partial<CreateCollarTypeInput>;
